<div class="date-picker-component">
    <div class="date-component" [formGroup]="form">
        <mat-form-field>
            <mat-label>{{ label }}</mat-label>
            <input style="width: 140px" matInput [formControlName]="controlName"  [matDatepicker]="picker">
            <mat-hint>{{ dateFormat }}</mat-hint>
            <mat-datepicker-toggle matIconSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <button *ngIf="showClearButton" mat-flat-button class="clear-button" (click)="clearForm()">
			<ng-container i18n="Clear@@filtersClearDateRangeButton:Clear">
				Clear
			</ng-container>
        </button>
    </div>
    <ng-container *ngIf="form.controls?.[controlName]?.hasError('matStartDateInvalid')">
        <mat-error>Invalid date date</mat-error>
    </ng-container>
</div>
